import React from 'react';
import {Link} from 'react-router-dom';
import Lightbox from "yet-another-react-lightbox";
import MetaTags from "../components/MetaTags";

const Otdelka: React.FC = () => {
    const [open, setOpen] = React.useState(false);
    const [image, setImage] = React.useState<number>(0);

    const images = [
        {src: "/image/Otdelka/kP3120106.jpg"},
        {src: "/image/Otdelka/kP3120120.jpg"},
        {src: "/image/Otdelka/kP3120121.jpg"},
        {src: "/image/Otdelka/kP3120122.jpg"},
        {src: "/image/Otdelka/kP3120123.jpg"},
        {src: "/image/Otdelka/kP3120124.jpg"},
        {src: "/image/Otdelka/kPC120080.jpg"},
        {src: "/image/Otdelka/kPC120084.jpg"},
    ];

    const viewImage = (event: any) => {
        setOpen(true)
        setImage(Number(event.target.id.replace(/\D/g, '')))
    }

    MetaTags(
        "Украшение одежды бисером",
        "Украшение одежды бисером. Нашивки в виде бабочек, листиков, снежинок и дельфинчиков из мелкого бисера."
    )

    return <>
        <h2>Украшение одежды бисером</h2>

        <div className="row catalog">
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Otdelka/mP3120106.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Бабочка"
                     id="image-0"
                     onClick={viewImage}
                />
                <p className="name">Бабочка</p>
            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Otdelka/mP3120120.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Листики"
                     id="image-1"
                     onClick={viewImage}
                />
                <p className="name">Листики</p>
            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Otdelka/mP3120121.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Листик"
                     id="image-2"
                     onClick={viewImage}
                />
                <p className="name">Листик</p>
            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Otdelka/mP3120122.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Листик"
                     id="image-3"
                     onClick={viewImage}
                />
                <p className="name">Листик</p>
            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Otdelka/mP3120123.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Листик"
                     id="image-4"
                     onClick={viewImage}
                />
                <p className="name">Листик</p>

            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Otdelka/mP3120124.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Листик"
                     id="image-5"
                     onClick={viewImage}
                />
                <p className="name">Листик</p>
            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Otdelka/mPC120076.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Снежинка"
                     id="image-6"
                     onClick={viewImage}
                />
                <p className="name">Снежинки</p>

            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Otdelka/mPC120084.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Дельфинчик"
                     id="image-7"
                     onClick={viewImage}
                />
                <p className="name">Дельфинчик</p>
            </div>
        </div>

        <Lightbox
            open={open}
            close={() => setOpen(false)}
            slides={[
                images[image], // Выбранный элемент
                ...images.slice(0, image), // Элементы до выбранного
                ...images.slice(image + 1) // Элементы после выбранного
            ]}
        />
    </>;
};

export default Otdelka;

